export default "/images/grad-registry.png?014eb562c769a180874855dae520eb07";